import styled from 'styled-components';

import ModeSelectionState from '@Components/molecules/ModeSelection/ModeSelectionState';
import TypingBox from '@Components/organisms/TypingBox/TypingBox';

export const StyledTypingBox = styled(TypingBox)`
  @media (min-width: ${(props) => props.theme.device.tablet}) {
    margin-top: 30px;
  }
`;

export const StyledModeSelectionState = styled(ModeSelectionState)`
  @media (max-width: ${(props) => props.theme.device.mobile}) {
    display: none;
  }
`;

export const AdTypingTestWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${(props) => props.theme.device.mobile}) {
    flex-direction: column-reverse;
  }
`;
